function toDataUrl(svg){
    return `data:image/svg+xml;utf8;base64,${window.btoa(svg)}`
}

export default class EventMarker{
    constructor(latLng, svg, radius){
        this.pos = latLng
        this.svg = toDataUrl(svg)
        this.radius = radius
    }

    static latLng(lat, lng){
        return lat !== null && lng !== null ? {
            lat: lat,
            lng: lng
        } : null
    }
}
